import React, { createContext, useContext, useState, useCallback } from "react";

const KaramikoContext = createContext(null);

// Fites del camí del bosc (per al traç lateral)
export const MILESTONES = ["inici", "espectacles", "valors", "qui-som", "contacte"];

// Panells que amaguen un mico 🐒
export const MONKEY_SPOTS = ["glup-glup", "cinc-postals", "feminisme", "arrelament", "conciliacio"];

export function KaramikoProvider({ children }) {
  const [found, setFound] = useState(() => new Set());

  const findMonkey = useCallback((id) => {
    setFound((prev) => {
      if (prev.has(id)) return prev;
      const next = new Set(prev);
      next.add(id);
      return next;
    });
  }, []);

  return (
    <KaramikoContext.Provider value={{ found, findMonkey, totalMonkeys: MONKEY_SPOTS.length }}>
      {children}
    </KaramikoContext.Provider>
  );
}

export function useKaramiko() {
  const ctx = useContext(KaramikoContext);
  if (!ctx) throw new Error("useKaramiko must be used within KaramikoProvider");
  return ctx;
}
